import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/v1/notifications", { params: { size: 20 } });
      setItems(data.data.items || []);
      setUnread(data.data.unread || 0);
    } catch {
      /* ignore polling errors */
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, [user, load]);

  const markRead = useCallback(async (id) => {
    await api.patch(`/v1/notifications/${id}/read`);
    load();
  }, [load]);

  const markAll = useCallback(async () => {
    await api.post("/v1/notifications/read-all");
    load();
  }, [load]);

  return (
    <NotificationContext.Provider value={{ items, unread, load, markRead, markAll }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationContext);
